import { render } from "./view_events.html?vue&type=template&id=2a78b536&external"
import script from "./view_events.js?vue&type=script&lang=js&external"
export * from "./view_events.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__